import {
  mdiBookEducationOutline,
  mdiBullhornOutline,
  mdiCloudDownloadOutline,
  mdiHomeOutline,
  mdiPipeValve,
} from '@mdi/js'

type IconProps = {
  path: string
  /** Em size — matches mobile tab visual weight (~34px at 12px base ≈ 1.4–1.5em) */
  size?: number
  /** Pixel size. Inline styles win over the default tab-icon class so listings can match mobile. */
  sizePx?: number
  title?: string
  className?: string
}

export function NavMdiIcon({ path, size = 1.45, sizePx, title, className }: IconProps) {
  const dim = sizePx != null ? `${sizePx}px` : `${size}em`
  return (
    <svg
      className={className ?? (sizePx != null ? undefined : 'nav-primary-tab-icon')}
      viewBox="0 0 24 24"
      width={dim}
      height={dim}
      style={sizePx != null ? { width: dim, height: dim } : undefined}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <path fill="currentColor" d={path} />
    </svg>
  )
}

export const TabIcons = {
  home: mdiHomeOutline,
  download: mdiCloudDownloadOutline,
  training: mdiBookEducationOutline,
  operators: mdiPipeValve,
  alert: mdiBullhornOutline,
} as const
